<app-base-send-queue
  [getTableDataApiMethodName]="getTableDataApiMethodName"
  [pageTitle]="pageTitle"
  pageId="app-reseller-send-queue"
  [showReseller]="false"
  [pageTagName]="tagName"
  [tabName]="tabName"
>
</app-base-send-queue>
